<template>
  <div v-if="extra">
    <h6>
      {{ title }}
      <span v-if="extra.floated" style="float: right">{{ $store.getters.device(extra.serial)[extra.name] }} {{ extra.unit }}</span>
      <span v-else>{{ $store.getters.device(extra.serial)[extra.name] }} {{ extra.unit }}</span>
    </h6>
    <hr v-if="extra.divider">
  </div>
</template>

<script>
export default {
  props: ['title', 'extra']
}
</script>

<style>
hr {
  color: #cccccc;
  border: 0;
  height: 1px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0));
}
</style>
